"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data;
exports.loadConfig = function (configuration) {
    data = configuration;
};
exports.getConfig = function (key) {
    if (process.env.NODE_ENV === 'production') {
        return data[key];
    }
    else {
        return process.env[key];
    }
};
//# sourceMappingURL=index.js.map